import React from 'react';
import { PopupBody, PopupContainer, PopupBottom } from './style';
import { Text } from '../../../UI/Text';
import { OuterIndent } from '../../../Layouts';
import { Delegate } from '../../../Containers/Delegate/Delegate';
import { HoverableFadingContainer } from '../../HoverableFadingContainer';

export const MemberPopup = ({ status, action, onClose }) => {
    return (
        <Delegate.Click onAction={onClose}>
            <PopupContainer>
                <PopupBody>
                    <OuterIndent indent={'0 0 12px 0 '}>
                        <Text alignCenter={true} weight={'bold'} color={'black'}>
                            {mapStatusToString(status)}
                        </Text>
                    </OuterIndent>
                    <OuterIndent indent={'0 0 12px 0'}>
                        <Text alignCenter={true} fontSize={12} weight={100} color={'black'} opacity={0.5}>
                            {mapStatusToDescription(status)}
                        </Text>
                    </OuterIndent>

                    <HoverableFadingContainer>
                        <Text
                            cursor={'pointer'}
                            alignCenter={true}
                            fontSize={12}
                            onClick={action}
                            weight={'bold'}
                            color={'red'}
                        >
                            {mapStatusToActionLabel(status)}
                        </Text>
                    </HoverableFadingContainer>
                </PopupBody>
                <PopupBottom />
            </PopupContainer>
        </Delegate.Click>
    );
};

MemberPopup.defaultProps = {
    status: 0,
    action: () => {},
    onClose: () => {},
};

const mapStatusToString = status => {
    switch (status) {
        case 0:
            return 'Waiting...';
        case 1:
            return 'Active';
        case 2:
            return 'Pending...';
        case 3:
            return 'Disabled';
        case 4:
            return 'Overdue';
        default:
            return 'Waiting...';
    }
};

const mapStatusToDescription = status => {
    switch (status) {
        case 0:
            return 'User must create a Tona account to book classes';
        case 1:
            return 'User is eligible to book classes';
        case 2:
            return 'User must accept invitation in Tona to book classes';
        case 3:
            return 'User is blocked from booking classes';
        case 4:
            return 'User is overdue on payments';
        default:
            return 'User must create a Tona account to book classes';
    }
};

const mapStatusToActionLabel = status => {
    switch (status) {
        case 0:
            return 'Resend email';
        case 1:
            return 'Disable user';
        case 2:
            return 'Resend invitation';
        case 3:
            return 'Activate';
        case 4:
            return 'Disable user';
        default:
            return 'Resend email';
    }
};



// WEBPACK FOOTER //
// ./src/UI/Components/Popups/MembersPopups/index.js